/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1270
 */

var r = require(/* 334 */"../1648/334")
module.exports = function (e) {
  return undefined !== e && (r(e, "value") || r(e, "writable"))
}
